import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SkipKidsAndAgeRateFilterService } from 'osn-shared';
import { combineLatest, Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { AgeRate } from '../../../common';
import { appendToParam } from '../../utils';
import { ClientConfigService } from '../client-config';
import { AGE_RATE_FILTER_SERVICE, AgeRateFilterAbstractService } from './age-rate-filter-abstract.service';
import { shouldCheckAgeRateToken } from './mpx-http-context-tokens';

@Injectable({ providedIn: 'root' })
export class AgeRateFilterInterceptor implements HttpInterceptor {
  private readonly bookmarkSlug = 'bookmark';
  private readonly ageFilterMapping: Partial<Record<AgeRate, string>> = {
    [AgeRate.FAMILY]: 'urn\\:www.citc.gov.sa:family',
    [AgeRate.PG]: 'urn\\:www.citc.gov.sa:pg',
    [AgeRate.Fifteen]: 'urn\\:www.citc.gov.sa:15',
    [AgeRate.Eighteen]: 'urn\\:www.citc.gov.sa:18',
    [AgeRate.EighteenR]: 'urn\\:www.citc.gov.sa:r18',
  };

  constructor(
    @Inject(AGE_RATE_FILTER_SERVICE) private readonly ageRateFilterService: AgeRateFilterAbstractService,
    private readonly configService: ClientConfigService,
    private readonly skipAgeRateFilterService: SkipKidsAndAgeRateFilterService
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req.clone();
    const shouldCheckAgeRate = this.skipAgeRateFilterService.shouldSkipFiltering() ? false : req.context.get(shouldCheckAgeRateToken);

    if (!this.configService.configAvailable$.getValue() || !shouldCheckAgeRate || req.url.includes(this.bookmarkSlug)) {
      return next.handle(request);
    }
    return combineLatest([this.ageRateFilterService.allParentalRating$, this.ageRateFilterService.hasValidProfileState$]).pipe(
      filter(([_0, hasValidProfileState]) => hasValidProfileState),
      take(1),
      switchMap(([allParentalRatings]) => {
        let params = request.params;

        const mappedAgeRate: string[] = allParentalRatings.map((rating) => this.ageFilterMapping[rating]);

        mappedAgeRate.forEach((rating) => (params = appendToParam(params, 'byRatings', '|', rating)));

        request = request.clone({ params });
        return next.handle(request);
      })
    );
  }
}
